import { initializeFaro, FetchTransport, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export function initFaro(): void {
  if (typeof window === 'undefined') return;

  // Every `NEXT_PUBLIC_*` here is read through direct property access: this
  // runs in the browser, and Next.js only inlines the value when it can see
  // the read statically. Under a bracket lookup the token below is always
  // `undefined` and Faro never initializes at all.
  const ingestToken = process.env.NEXT_PUBLIC_FARO_INGEST_TOKEN;
  if (!ingestToken) return;

  // Session-based sampling: a sampled session sends ALL its signals, an
  // unsampled one sends none. Tracing spans dominate the `/api/faro` ingest
  // volume (the top Vercel Function by invocations), so sampling sessions is
  // the highest-leverage cost control. Defaults to 10%; override per env via
  // NEXT_PUBLIC_FARO_SAMPLING_RATE (e.g. 1 in prod for full fidelity, lower in
  // staging). Clamped to [0, 1]; invalid values fall back to the default.
  const rawRate = process.env.NEXT_PUBLIC_FARO_SAMPLING_RATE?.trim();
  const parsedRate = rawRate ? Number(rawRate) : Number.NaN;
  const samplingRate = Number.isFinite(parsedRate)
    ? Math.min(1, Math.max(0, parsedRate))
    : 0.1;

  initializeFaro({
    app: {
      name: 'platform-admin',
      version: process.env.NEXT_PUBLIC_APP_VERSION ?? '0.0.0',
      environment: process.env.NEXT_PUBLIC_DEPLOY_ENV ?? 'development',
    },
    sessionTracking: {
      samplingRate,
    },
    instrumentations: [
      ...getWebInstrumentations({ captureConsole: false }),
      new TracingInstrumentation({
        instrumentationOptions: {
          // Propagate W3C traceparent to all same-origin API calls
          propagateTraceHeaderCorsUrls: [new RegExp(`^${window.location.origin}`)],
        },
      }),
    ],
    transports: [
      new FetchTransport({
        url: '/api/faro',
        requestOptions: {
          headers: { Authorization: `Bearer ${ingestToken}` },
        },
      }),
    ],
  });
}
